import React, { useEffect } from "react";

//boostrap
import { Container } from "reactstrap";

//components
import { NavigationComponent } from "@components/layouts";

//utils
import { LoaderPage, navigation } from "@utils";

//call Action
import { actLoadTicket } from "@actions";

//redux
import { useDispatch, useSelector } from "react-redux";

//components
import { TabsMain } from "@components/admin/Models";

function ModelsPage() {
    const dispatch = useDispatch();
    const mainMenu = navigation && navigation.mainAdmin;

    useEffect(() => {
        const fetchData = async () => {
            dispatch(actLoadTicket());
        };
        //fetch data
        fetchData();
    }, [dispatch]);

    const dataTicket = useSelector(
        (state) => (state.loadTicket) || []
    );

    // const storeTicket = dataTicket && dataTicket.data;
    return (
        <React.Fragment>
            {dataTicket.isLoading && <LoaderPage />}
            {!dataTicket.isLoading && (
                <React.Fragment>
                    <NavigationComponent data={mainMenu} />
                    <div className="wrapper -OnBoardingPage">
                        <Container className="-box-shadow bg-white p-4">
                            <TabsMain />
                        </Container>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default ModelsPage;